import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { SmartReviewAccessService } from '../api/smart-review-access.service';

/**
 * Restringe as rotas administrativas do Smart Review (gates, curadoria e futuras
 * features) a quem tem a capability `smartreview.admin`. Aplicado na rota pai do
 * AdminShell, centralizando a checagem que antes era duplicada nos componentes.
 *
 * Quem decide é o backend (autoridade real), via probe em `/admin/gates` — rota
 * resolvida antes do gate TFVC, então um admin sem TFVC passa. A mensagem do 403
 * é exibida pelo toaster app-level do PO (o probe não usa X-PO-No-Message), por
 * isso o guard não emite toast próprio; ele apenas cancela a navegação.
 */
@Injectable({
  providedIn: 'root'
})
export class SmartReviewAdminGuard {
  constructor(private accessService: SmartReviewAccessService) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return this.accessService.checkAdminAccess().pipe(
      map(() => true),
      catchError(() => of(false))
    );
  }
}
